module.exports = __webpack_public_path__ + "static/media/AI-search-campaign-02.3973d584.svg";